<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="tochead">Contents</h1>
<h2 class="toc_fm"><a href="#/xhtml/06_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc_fm"><a href="#/xhtml/07_Glossary">Glossary</a></h2>
<h2 class="toc_chap1"><a href="#/xhtml/08_Chapter_01"><span class="tochang"><span class="bold">Chapter One</span></span> Noble Purpose</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/09_Chapter_02" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Two</span></span> In the Field</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_03" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Three</span></span> Behind Toothed Wire</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_04" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Four</span></span> Prison Camp Lines</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_05" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Five</span></span> Gatekeeper</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_06" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Six</span></span> Princeton</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/14_Chapter_07" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Seven</span></span> Standard-Bearer</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_08" title="Link target outside of Sample"><span class="tochang"><span class="bold">Chapter Eight</span></span> The Long Day’s Task is Done</span></h2>
<h2 class="toc_bm"><span href="#/xhtml/16_Epilogue" title="Link target outside of Sample">Epilogue</span></h2>
<h2 class="toc_bma"><span href="#/xhtml/17_Afterword" title="Link target outside of Sample">Afterword</span></h2>
<h2 class="toc_bm1"><span href="#/xhtml/18_Appendix_I" title="Link target outside of Sample"><span class="tochang1"><em class="italic">Appendix I</em></span> The Christ of Mory</span></h2>
<h2 class="toc_bm1"><span href="#/xhtml/19_Appendix_II" title="Link target outside of Sample"><span class="tochang1"><em class="italic">Appendix II</em></span> The Chestnuts</span></h2>
<h2 class="toc_bm1"><span href="#/xhtml/20_Appendix_III" title="Link target outside of Sample"><span class="tochang1"><em class="italic">Appendix III</em></span> A Voice from the Past</span></h2>
<h2 class="toc_bma"><span href="#/xhtml/21_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?d389ccb6